'use strict';

import './assign-polyfill'

import ScrollMagic from 'ScrollMagic'

import './DrawSVGPlugin.min'
import 'waypoints/lib/noframework.waypoints.min'
import 'animation.gsap'
import i1 from './illustrations/i1'
import i2 from './illustrations/i2'
import i3 from './illustrations/i3'
import i4 from './illustrations/i4'
import i5 from './illustrations/i5'
import i6 from './illustrations/i6'

import { animateBlock, animateScrolling, animateWaypoint, animateRepeat, animateItem, animateCard, animateAnim } from './animations'
import { select, parseData,scrollTo } from "@assets/scripts/utils";
import './icons'
import { scroller } from './scroller'
import AnimatedFigure from './animations/AnimatedFigure'

const controller = new ScrollMagic.Controller()

window.addEventListener('load', e => {

    const sectionAnimations = select('[data-animated-section]').map(element => {
        const section = element.getAttribute('data-animated-section')
        const target = document.getElementById(section)
        const animation = new AnimatedFigure(element, parseData(element))
        return { section, animation }
    })

    animateAnim('[data-anim]')

    animateCard('.article-card')

    animateItem('.item', { sectionAnimations })

    animateRepeat('.animated-figure--repeat').forEach(animation => {
        animation.count = -1
        animation.run()
    })

    animateWaypoint('.animated-figure--waypoint').forEach(animation => {
        new Waypoint({
            element: animation.el,
            handler (dir) {
                if(dir !== 'down') return
                animation.go()
                // this.destroy()
            },
            offset: '50%'
        })
    })

    animateScrolling('.animated-figure--scroll').map((scroll, idx) => {
        const duration = scroll.duration * 50 + '%'
        new ScrollMagic.Scene({
            triggerElement: scroll.el,
            duration: duration,
            triggerHook: 0.5
        })
            .setTween(scroll.timeline)
            .addTo(controller)
    })

    animateBlock('[data-animate]', {})

    select('.intro__arrow').forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault()
            scrollTo(window.innerHeight)
        })
    })

    const scrollers = scroller('[data-scroll-to]')

    // Show/hide scroll button

    const scrollButton = select('.scroll-top-button')[0]

    new Waypoint({
        element: document.body,
        handler (dir) {
            scrollButton.classList[dir === 'down' ? 'remove' : 'add']('hidden')
        },
        offset: '-50%'
    })

    i1()
    i2()
    i3()
    i4()
    i5()
    i6()

})


